import { useContext, useEffect, useState } from "react";
import { Context } from "../context/Context";
import WarningAlert from "./sweeAlerts/WarningAlert";
import { Link } from "react-router-dom";
import "./Settings.css";
import { UpdateNotifStatus, UpdateUser } from "../api/api";
import ErrorAlert from "./sweeAlerts/ErrorAlert";
import ErrorToast from "./toasts/ErrorToast";

const Settings = () => {
  const {
    handleShowBackupModal,
    setSettingsPage,
    settingsPage,
    notificationStatus,
    setNotificationStatus,
    authUser,
    setAuthUser,
    setIsLoading,
  } = useContext(Context);

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("templateCustomizer-vertical-menu-template--Style"),
  );
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  const handleUpdateNotifStatus = () => {
    setIsLoading(true);
    UpdateNotifStatus({
      status: `${!notificationStatus}`,
    }).then(({ data }) => {
      setNotificationStatus(data.status);
      localStorage.setItem("get_notification_status", data.status);
      setIsLoading(false);
    });
  };
  const handleUpdateAdminAccess = () => {
    if (authUser.is_admin) {
      WarningAlert(
        "هشدار",
        "با غیرفعال شدن دسترسی مدیر امکان تغییر در محیط کاربری را نخواهید داشت",
      ).then(function (result) {
        if (result.value) {
          setIsLoading(true);
          UpdateUser({ is_admin: authUser.is_admin ? 0 : 1 })
            .then(({ data }) => {
              let updateAuthUser = { ...authUser };
              updateAuthUser.is_admin = authUser.is_admin ? 0 : 1;
              setAuthUser(updateAuthUser);
              setIsLoading(false);
              localStorage.setItem("user", JSON.stringify(updateAuthUser));
            })
            .catch((jqXHR) => {
              setIsLoading(false);
              let errorMessage = "";
              switch (jqXHR.response.status) {
                case 400:
                  for (var key in jqXHR.response.data) {
                    if (jqXHR.response.data.hasOwnProperty(key)) {
                      return ErrorToast(jqXHR.response.data.message);
                    }
                  }
                  errorMessage =
                    "An unexpected error occurred. Please try again.";
              }
            });
        }
      });
    } else {
      WarningAlert(
        "هشدار",
        "با فعال شدن دسترسی مدیر امکان تغییر در محیط کاربری را خواهید داشت",
      ).then(function (result) {
        if (result.value) {
          setIsLoading(true);
          UpdateUser({ is_admin: authUser.is_admin ? 0 : 1 })
            .then(({ data }) => {
              let updateAuthUser = { ...authUser };
              updateAuthUser.is_admin = authUser.is_admin ? 0 : 1;
              setAuthUser(updateAuthUser);
              localStorage.setItem("user", JSON.stringify(updateAuthUser));
              setIsLoading(false);
            })
            .catch((jqXHR) => {
              setIsLoading(false);
              let errorMessage = "";
              switch (jqXHR.response.status) {
                case 400:
                  for (var key in jqXHR.response.data) {
                    if (jqXHR.response.data.hasOwnProperty(key)) {
                      return ErrorToast(jqXHR.response.data.message);
                    }
                  }
                  errorMessage =
                    "An unexpected error occurred. Please try again.";
              }
            });
        }
      });
    }
  };
  const handleChangeDarkMode = () => {
    let theme = localStorage.getItem(
      "templateCustomizer-vertical-menu-template--Style",
    );
    if (theme == "dark") {
      localStorage.setItem(
        "templateCustomizer-vertical-menu-template--Style",
        "light",
      );
    } else {
      localStorage.setItem(
        "templateCustomizer-vertical-menu-template--Style",
        "dark",
      );
    }
    window.location.reload();
  };
  const installApp = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // نمایش پنجره نصب
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        setDeferredPrompt(null);
        setIsInstallable(false);
      });
    }
  };

  return (
    <div className="settings">
      <ul className="list-group">
        <li className="list-group-item border-0">
          <div className="d-flex justify-content-between">
            <div>
              <i className="bx bxs-check-shield me-2 icon-success-app"></i>
              <span>دسترسی مدیر</span>
            </div>
            <div className="form-check form-switch">
              <label
                className="switch switch-success-app w-auto"
                style={{ marginLeft: "2.8rem" }}
              >
                <input
                  type="checkbox"
                  className="switch-input"
                  onChange={handleUpdateAdminAccess}
                  checked={authUser.is_admin ? "checked" : ""}
                />
                <span className="switch-toggle-slider">
                  <span className="switch-on"></span>
                  <span className="switch-off"></span>
                </span>
              </label>
            </div>
          </div>
        </li>
        <li className="list-group-item border-0">
          <div className="d-flex justify-content-between">
            <div>
              <i className="bx bxs-bell me-2 icon-success-app"></i>
              <span>دریافت اعلان</span>
            </div>
            <div>
              <label
                className="switch switch-success-app w-auto"
                style={{ marginLeft: "2.8rem" }}
              >
                <input
                  type="checkbox"
                  className="switch-input"
                  onChange={handleUpdateNotifStatus}
                  checked={notificationStatus ? "checked" : ""}
                />
                <span className="switch-toggle-slider">
                  <span className="switch-on"></span>
                  <span className="switch-off"></span>
                </span>
              </label>
            </div>
          </div>
        </li>
        <li className="list-group-item border-0">
          <div className="d-flex justify-content-between">
            <div>
              <i className="bx bxs-moon me-2 icon-success-app"></i>
              <span>حالت تیره</span>
            </div>
            <div>
              <label
                className="switch switch-success-app w-auto"
                style={{ marginLeft: "2.8rem" }}
              >
                <input
                  type="checkbox"
                  className="switch-input"
                  onChange={handleChangeDarkMode}
                  checked={darkMode == "dark" ? "checked" : ""}
                />
                <span className="switch-toggle-slider">
                  <span className="switch-on"></span>
                  <span className="switch-off"></span>
                </span>
              </label>
            </div>
          </div>
        </li>
        {authUser.is_admin ? (
          <li className="list-group-item border-0">
            <div className="d-flex justify-content-between">
              <div
                style={{ cursor: "pointer" }}
                onClick={handleShowBackupModal}
              >
                <i className="bx bxs-cloud-upload me-2 icon-success-app"></i>
                <span>پشتیبان گیری</span>
              </div>
            </div>
          </li>
        ) : null}

        <li
          className={
            settingsPage.slug == "backup-management"
              ? "list-group-item border-0 active"
              : "list-group-item border-0"
          }
        >
          <div className="d-flex justify-content-between">
            <div
              style={{ cursor: "pointer" }}
              onClick={() =>
                setSettingsPage({
                  name: "مدیریت پشتیبان",
                  slug: "backup-management",
                })
              }
            >
              <Link to={"/settings/backup-management"}>
                <i className="bx bx-reset bx-rotate-270 me-2 icon-success-app"></i>
                <span>مدیریت پشتیبان</span>
              </Link>
            </div>
          </div>
        </li>
        <li
          className={
            settingsPage.slug == "help"
              ? "list-group-item border-0 active"
              : "list-group-item border-0"
          }
        >
          <div className="d-flex justify-content-between">
            <div style={{ cursor: "pointer" }}>
              <Link
                to={"/settings/help"}
                onClick={() =>
                  setSettingsPage({
                    name: "راهنما",
                    slug: "help",
                  })
                }
              >
                <i className="bx bxs-help-circle me-2 icon-success-app"></i>
                <span>راهنما</span>
              </Link>
            </div>
          </div>
        </li>
        <li
          className={
            settingsPage.slug == "about-us"
              ? "list-group-item border-0 active"
              : "list-group-item border-0"
          }
        >
          <div className="d-flex justify-content-between">
            <div
              style={{ cursor: "pointer" }}
              onClick={() =>
                setSettingsPage({
                  name: "درباره ما",
                  slug: "about-us",
                })
              }
            >
              <Link to={"/settings/about-us"}>
                <i className="bx bxs-info-circle me-2 icon-success-app"></i>
                <span>درباره ما</span>
              </Link>
            </div>
          </div>
        </li>
        {isInstallable && (
          <li className="list-group-item border-0">
            <div className="d-flex justify-content-between">
              <div style={{ cursor: "pointer" }} onClick={installApp}>
                <i className="bx bx-download me-2 icon-success-app"></i>
                <span>نصب برنامه</span>
              </div>
            </div>
          </li>
        )}
        {authUser.is_admin ? (
          <li className="list-group-item border-0">
            <div className="d-flex justify-content-between">
              <div
                style={{ cursor: "pointer" }}
                onClick={() =>
                  WarningAlert(
                    "هشدار!",
                    "با بازنشانی نرم افزار تمامی اطلاعات شما حذف می شود و نرم افزار مجدد بارگزاری خواهد شد. آیا از انجام این کار مطمئن هستید؟",
                    "بله، مطمئن هستم",
                    "لغو",
                  )
                }
              >
                <i className="bx bx-reset me-2 icon-success-app"></i>
                <span>بازنشانی نرم افزار</span>
              </div>
            </div>
          </li>
        ) : null}
      </ul>
    </div>
  );
};

export default Settings;
